


















































import { Vue, Component, Prop, Provide } from "vue-property-decorator";
import EditPage from "@/components/EditPage";
import { Globals } from "@/Globals";

@Component
export default class TagesSaldenBestaetigungen extends EditPage {
  // @Prop({ default: null }) protected zeitbereich!: APIZeitbereich | null;
  @Prop({}) protected zeitbereichUebergabe: any;
  constructor() {
    super();
    this.query = "WEB_PZE_Bestaetigungen";
    this.showLoading = true;
  }
  private deleteVisible: boolean = false;

  public created() {
    this.zeitbereich = this.zeitbereichUebergabe;
    // this.mountedBase();
  }
  public bewDelete() {
    if (this.data && this.data.aic_Bew_pool) {
      this.onDelete(this.data.aic_Bew_pool, "");
      this.$emit("back");
    }
  }
  protected initialize() {
    if (this.data && this.data.aic_Bew_pool) {
      this.deleteVisible = true;
    }
  }
}
